import Marquee from "react-fast-marquee";

const items = [
  "Four Lenses Classes",
  "Custom Leadership Consulting",
  "Clarity",
  "Discipline",
  "Resilience",
];

export default function EditorialMarquee() {
  return (
    <section className="py-16 border-y border-white/10 bg-primary text-white overflow-hidden" data-testid="marquee">
      <Marquee speed={38} gradient={false} autoFill>
        {items.map((t, i) => (
          <span key={i} className="flex items-center">
            <span className="font-display font-black uppercase text-4xl sm:text-6xl tracking-tighter px-10">
              {t}
            </span>
            <span className="h-3 w-3 bg-white rotate-45 mx-4" />
          </span>
        ))}
      </Marquee>
    </section>
  );
}
